import React, 
     { useState , 
       useEffect,
       useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import '../../App.css'
import '../../style.css';

// --------------------定数---------------------
export const baseId = "molecule-game-boy-logo";
const Red_Img       = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F001_red_img.png?alt=media&token=b5388139-e5b5-4e30-ae73-9a2160ccf351"
const Hitokage_Img  = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F002_%E3%83%92%E3%83%88%E3%82%AB%E3%82%B2.png?alt=media&token=a6bb7de0-9ac6-4ea6-8dd1-eae983d5db96"

function GBOpening() {

  return (
    <Box sx={{ m : 1 , p : 4}}>
      {/* 画面 */}
      <Paper sx={{ m: 1, p: 1 ,
              bgcolor      : '#f5f5dc'  ,
              borderRadius : "1px"      , 
              height       : "250px"    ,
              width        : '250px'    ,
              position     : 'absolute' , // 絶対位置指定
              top          : '20px'     , // 縦位置を50pxに指定
              left         : '40px'     , // 横位置を20pxに指定
      }}>
        <Grid container spacing={0}>
            {/* タイトル表示 */}
            <Grid item xs={12} align="center">
              <Typography
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "27px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>ポケットモンスター</Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Typography
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "20px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>POKET MONSTERS</Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Typography
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "15px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>Red Version</Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Typography
                className="blinking-text" // 点滅するクラスを追加
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "15px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>Start ボタンをおしてね</Typography>
            </Grid>

            {/* レッドの画像表示 */}
            <Grid item xs={6} align="right">
              <img
                src    = {Red_Img}
                style={{ width: '60%', height: 'auto' }} // 画像の幅を110%に設定
                />
            </Grid>

            {/* ヒトカゲの画像表示 */}
            <Grid item xs={6} align="left">
              <img
                src    = {Hitokage_Img}
                style={{ width: '60%', height: 'auto' , transform: 'translateY(40px)'}} // 画像の幅を110%に設定
                />
            </Grid>
            <Grid item xs={12} align="center">
              <Typography
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "12px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                }}>@1995 GAME FREAK Inc.</Typography>
            </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={2}>
          <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  );
}

export default GBOpening;
